<template>
  <div class="login login-register">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="login-box card">
      <div class="card-body">
        <h3 class="box-title m-b-20">{{ page_title }}</h3>
        <div class="form-group ">
          <div class="col-xs-12">
            <input v-model="username" class="form-control form-control-sm" required="" placeholder="Username"
                   type="text" id="username">
          </div>
        </div>

        <div v-if="!sent" class="form-group text-center">
          <a href="/#/login/">
            <div class="col-xs-12 p-b-20 submit-button">
              <button class="btn btn-block btn-lg btn-info btn-rounded">Back</button>
            </div>
          </a>
        </div>

        <div v-if="!sent" class="form-group text-center">
          <div class="col-xs-12 p-b-20 submit-button">
            <button v-on:click="sendLink()" class="btn btn-block btn-lg btn-info btn-rounded">Send reset link</button>
          </div>
        </div>

        <div v-if="sent">
          <span>We have sent a link to reset your password to {{username}}.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Send Reset Link',
    },
    name: 'SendResetLink',
    data () {
      return {
        page_title: 'Send Reset Link',
        data: {},
        username: null,
        password: null,
        isLoading: false,
        sent: false,
      }
    },
    components: {
      Loading,
    },
    methods: {
      sendLink: function () {
        if (!this.username || this.username.length == 0) {
          this.showToastError('Please enter a valid username.')
          return
        }

        this.isLoading = true

        this.$http
          .get(process.env.API_BASE_URL + 'sent-reset-password-link/?username=' + encodeURIComponent(this.username))
          .then(response => {
            console.log('login success')
            console.log(response.data)
            this.sent = true

          })
          .catch(error => {
            console.log(error.response)
            this.showToastError('Something went wrong.')
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    mounted: function () {
      $('body').addClass('logged-out')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }

  textarea {
    width: 100%;
  }
</style>
<style>

  body.logged-out .page-wrapper {
    margin-left: 0px;
  }

  body.logged-out .sidebartoggler, body.logged-out .topbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/SendResetLink.vue